import { render, staticRenderFns } from "./referenceDialog.vue?vue&type=template&id=2cd42cca&"
import script from "./referenceDialog.vue?vue&type=script&lang=js&"
export * from "./referenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports